import { Field, TextInput, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { EMPTY_LIST } from '@/lib/utils';

// Local, not the declarations slice's sections: that form is inbound, two-step and route-level.

/**
 * Props:
 *   name      the form key
 *   label     the field's own label
 *   required  marks it and adds the required rule
 *   readOnly  a value the allocation fixes, shown greyed
 *   format    (value) => display text; read-only fields only, so the stored value stays the server's
 */
export const DeclarationTextField = ({
  name,
  label,
  required = false,
  readOnly = false,
  format,
}) => (
  <Field name={name} required={required && !readOnly}>
    {({ id, value, onChange, onBlur, status, message }) => (
      <TextInput
        id={id}
        name={name}
        label={label}
        value={readOnly && format ? format(value) : value}
        onChange={onChange}
        onBlur={onBlur}
        status={status}
        message={message}
        required={required}
        disabled={readOnly}
        readOnly={readOnly}
      />
    )}
  </Field>
);

/**
 * Props:
 *   name        the form key
 *   label       the field's own label
 *   options     the dropdown's choices
 *   required    marks it and adds the required rule
 *   searchable  turns on the dropdown's own search box
 */
export const DeclarationSelectField = ({
  name,
  label,
  options = EMPTY_LIST,
  required = false,
  searchable = false,
}) => {
  const t = useTranslations();

  return (
    <Field name={name} required={required}>
      {({ id, value, onChange, onBlur, status, message }) => (
        <Dropdown
          id={id}
          name={name}
          label={label}
          placeholder={t('COMMON_SELECT')}
          options={options}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          required={required}
          searchable={searchable}
        />
      )}
    </Field>
  );
};
